/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getMonthlyDataAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const monthlyData = createSlice({
  name: "Subscribed User Paid Reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMonthlyDataAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getMonthlyDataAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getMonthlyDataAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default monthlyData.reducer;
